module.exports = __webpack_public_path__ + "static/service-roofrepair-98bc8219973d608b7e1c794350bfa8b0.jpg";